/**
 * Landing for the path "/ret/:s/:c/:k" (school-serial, code, key)
 * people get this url to find their application, but router replaces it with "/" ("/form") to prevent browser history from caching it
 * url parameters are stored in appStore as returnKeys
 * then we navigate to path "/" ReturnPage, without any url parameters
 */

import { useEffect } from "react"
import { useAppStore } from "../store/appStore"
import {
  useParams,
  useNavigate,
} from "react-router-dom"


export const Hopper = () => {

  // console.log('entered hopper')

  const navigate = useNavigate()
  const { s, c, k } = useParams()
  const returnKeys = useAppStore(state => state.returnKeys)
  const setReturnKeys = useAppStore(state => state.setReturnKeys)

  useEffect(()=>{
    setReturnKeys({nr: s, code: c, key: k})
    // console.log('keys', s,c,k)
    // console.log('navigating to return page')
      navigate('/', { replace: true })
  },[returnKeys])

  return (
    <></>
  )
}
